module.exports = {
  "zones": {
    "America/Jamaica": ["z", {
      "wallclock": 441763200000,
      "format": "EST",
      "abbrev": "EST",
      "offset": -18000000,
      "posix": 441781200000,
      "save": 0
    }, {
      "wallclock": 126230400000,
      "format": "E%sT",
      "abbrev": "EST",
      "offset": -18000000,
      "posix": 126248400000,
      "save": 0,
      "rules": "US"
    }, {
      "wallclock": -1827705600000,
      "format": "EST",
      "abbrev": "EST",
      "offset": -18000000,
      "posix": -1827687170000,
      "save": 0
    }, {
      "wallclock": -2524521600000,
      "format": "KMT",
      "abbrev": "KMT",
      "offset": -18430000,
      "posix": -2524503170000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -18430000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "US": [{
      "from": 2007,
      "to": 1.7976931348623157e+308,
      "month": 2,
      "day": [0, 8],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 2007,
      "to": 1.7976931348623157e+308,
      "month": 10,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1967,
      "to": 2006,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1987,
      "to": 2006,
      "month": 3,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1976,
      "to": 1986,
      "month": 3,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1975,
      "to": 1975,
      "month": 1,
      "day": [7, 23],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1974,
      "to": 1974,
      "month": 0,
      "day": [7, 6],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1967,
      "to": 1973,
      "month": 3,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1945,
      "to": 1945,
      "month": 7,
      "day": [7, 14],
      "time": 1380,
      "clock": "posix",
      "save": 60,
      "letter": "P",
      "saved": 3600000
    }, {
      "from": 1945,
      "to": 1945,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1942,
      "month": 1,
      "day": [7, 9],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "W",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1919,
      "month": 2,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1919,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }]
  }
};